<template>
  <div :class="`scs-button ${disabled ? 'disabled' : ''}`">
    <h5 v-if="!processing">{{ text }}</h5>
    <round-button-with-icon v-if="processing" icon="spinner" />
  </div>
</template>
<script>
import RoundButtonWithIcon from "./RoundButtonWithIcon.vue";
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  components: { RoundButtonWithIcon },
  props: ["text", "disabled", "processing"],
};
</script>
<style scoped>
.scs-button {
  width: 200px;
  height: 40px;
  background-color: var(--contrastColor);
  filter: drop-shadow(0 0 2px var(--secondaryColor));
  color: var(--backgroundColor);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
}

.disabled {
  background-color: var(--secondaryColor);
  cursor: not-allowed;
}
</style>
